import { render } from "./LatestCommentsPage.vue?vue&type=template&id=38d01cae"
import script from "./LatestCommentsPage.vue?vue&type=script&lang=js"
export * from "./LatestCommentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__